import {useContext} from 'react';

import BannerContext from '../../contexts/BannerContext';

const useBanner = () => {
  return useContext(BannerContext);
};

export default useBanner;
